import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { AdminLoanDocument, type AdminLoanQuery } from 'graphql/generated/graphql';

export type TAdminLoan = AdminLoanQuery['adminLoan'];

const useAdminLoan = (): [TAdminLoan | null, boolean] => {
  const { data, loading } = useQuery(AdminLoanDocument);
  const loan = get(data, 'adminLoan', null);

  return [loan, loading];
};

export default useAdminLoan;
